import { useState } from 'react';

const lowerCase = st => st.toLowerCase();

export const useFilteredSlides = (slides) => {
  const [searchText, setSearchText] = useState('');

  const preIndexedSlides = slides.map((slide, index) => ({
    ...slide,
    index
  }));

  const filteredAndIndexedSlides = preIndexedSlides.filter(slide => lowerCase(slide.name).includes(lowerCase(searchText).trim()));

  return [filteredAndIndexedSlides, searchText, setSearchText];
};
